import { motion } from 'framer-motion';

export const KpiStrip = ({ items, testId }) => (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5" data-testid={testId}>
        {items.map((k, i) => {
            const Icon = k.icon;
            return (
                <motion.div
                    key={k.id}
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.05 }}
                    className="rounded-xl border bg-card p-4 transition-transform duration-200 hover:-translate-y-0.5"
                    data-testid={`kpi-${k.id}`}
                >
                    <div className="flex items-center justify-between gap-2">
                        <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">{k.label}</p>
                        <Icon className={`h-4 w-4 ${k.tone}`} />
                    </div>
                    <p className="mt-2 font-heading text-3xl font-bold tabular-nums" data-testid={`kpi-${k.id}-value`}>{k.value ?? '—'}</p>
                    {k.hint && <p className="mt-1 truncate text-xs text-muted-foreground">{k.hint}</p>}
                </motion.div>
            );
        })}
    </div>
);
